<template>
 <div class="card-detalhes-titulo">  
        <div class="unidade-representante">
            <div class="titulo-conteudo-cabecalho"> Representante: &nbsp; <div class="label-cabecalho">{{infoTitulo.nomeRepresentante}}</div></div>
            <div class="titulo-conteudo-cabecalho"> Unidade: &nbsp; <div class="label-cabecalho">{{ empresaSelecionada }}</div></div>
        </div>    
        <g-card :temCabecalho="false" :expansivel="false">
            <div class="conteudo-card-detalhes-titulo espacamento-detalhes">
                <div class="titulo-grupo-detalhes">Detalhes</div>
                <div class="grupo-documento">
                    <div class="documento-titulo">
                        <div class="titulo-conteudo-detalhes"> Título </div>
                        <div class="label-conteudo">{{infoTitulo.codigoTituloFormatado}}</div>
                    </div>

                    <div class="duplica-cliente">
                        <div class="titulo-conteudo-detalhes"> Cliente </div>
                        <div class="label-conteudo detalhes" @click="direcionaConsultaCliente(clienteId, unidadeId)">{{infoTitulo.codigoCliente}} - {{infoTitulo.razaoSocial}}</div>
                    </div>


                    <div class="documento-docOrigem">
                        <div class="titulo-conteudo-detalhes"> Documento Origem </div>
                        <div class="label-conteudo">{{infoTitulo.numeroNotaFiscal}}</div>
                    </div>

                    <div class="documento-tipoDocOrigem">
                        <div class="titulo-conteudo-detalhes"> Tipo Doc. Origem </div>
                        <div class="label-conteudo">{{infoTitulo.tipoDocumentoEnumTexto}}</div>
                    </div>

                    <div class="documento-situacaoPgto">
                        <div class="titulo-conteudo-detalhes"> Situação Pagamento </div>
                        <div class="label-conteudo">{{infoTitulo.pagamentoDocumentoEnumTexto}}</div>
                    </div>

                    <div class="documento-situacaoTitulo">
                        <div class="titulo-conteudo-detalhes"> Situação Título </div>
                        <div class="label-conteudo">{{infoTitulo.situacaoDocumentoEnumTexto}}</div>
                    </div>

                    <div class="documento-dataEmissao">
                        <div class="titulo-conteudo-detalhes"> Data Emissão </div>
                        <div class="label-conteudo">{{infoTitulo.dataEmissaoDocumentoFormatada}}</div>
                    </div>

                    <div class="documento-vencimentoCDesc">
                        <div class="titulo-conteudo-detalhes"> Vencto c/ Desconto </div>
                        <div class="label-conteudo">{{infoTitulo.dataVencimentoComDescontoFormatada}}</div>
                    </div>

                    <div class="documento-desconto">
                        <div class="titulo-conteudo-detalhes"> % Desconto </div>
                        <div class="label-conteudo">{{infoTitulo.porcentagemDesconto}}</div>
                    </div>

                    <div class="documento-vencimentoSDesc">
                        <div class="titulo-conteudo-detalhes"> Vencto s/ Desconto </div>
                        <div class="label-conteudo">{{infoTitulo.dataVencimentoSemDescontoFormatada}}</div>
                    </div>

                    <div class="documento-venctoProrrag">
                        <div class="titulo-conteudo-detalhes"> Vencto Prorrogado </div>
                        <div class="label-conteudo">{{infoTitulo.dataProrrogacaoVencimentoFormatada}}</div>
                    </div>

                    <div class="documento-diasAtraso">
                        <div class="titulo-conteudo-detalhes"> Dias em Atraso </div>
                        <div class="label-conteudo">{{infoTitulo.diasAtraso}}</div>
                    </div>


                    <div class="documento-juros">
                        <div class="titulo-conteudo-detalhes"> % Juros Mora </div>
                        <div class="label-conteudo">{{infoTitulo.jurosDemora}}</div>
                    </div>

                    <div class="documento-despesaFinanc">
                        <div class="titulo-conteudo-detalhes"> Despesa Financeira </div>
                        <div class="label-conteudo">R${{infoTitulo.valorDespesaFinanceira}}</div>
                    </div>

                    <div class="documento-valorBruto">
                        <div class="titulo-conteudo-detalhes"> Valor Bruto </div>
                        <div class="label-conteudo">R${{infoTitulo.valorBruto}}</div>
                    </div>

                    <div class="documento-valorLiq">
                        <div class="titulo-conteudo-detalhes"> Valor Liquido </div>
                        <div class="label-conteudo">R${{infoTitulo.valorLiquido}}</div>
                    </div>

                    <div class="documento-valorFatura">
                        <div class="titulo-conteudo-detalhes"> Valor Fatura </div>
                        <div class="label-conteudo">R${{infoTitulo.valorFatura}}</div>
                    </div>

                    <div class="documento-valorSaldo">
                        <div class="titulo-conteudo-detalhes"> Valor Saldo </div>
                        <div class="label-conteudo">R${{infoTitulo.valorSaldo}}</div>
                    </div>

                    <div class="documento-portador">
                        <div class="titulo-conteudo-detalhes"> Portador </div>
                        <div class="label-conteudo">{{infoTitulo.nomePortador}}</div>
                    </div>

                    <div class="documento-tipoPortador">
                        <div class="titulo-conteudo-detalhes"> Tipo Portador </div>
                        <div class="label-conteudo">{{infoTitulo.tipoPortadorEnumTexto}}</div>
                    </div>

                    <div class="documento-tituloBanc">
                        <div class="titulo-conteudo-detalhes"> Título Bancário </div>
                        <div class="label-conteudo">{{infoTitulo.numeroTituloBancario}}</div>
                    </div>

                    <div class="documento-agencia">
                        <div class="titulo-conteudo-detalhes"> Agência </div>
                        <div class="label-conteudo">{{infoTitulo.codigoAgencia}} - {{infoTitulo.digitoAgencia}}</div>
                    </div>

                    <div class="documento-condicaoPgto">
                        <div class="titulo-conteudo-detalhes"> Condição Pagamento </div>
                        <div class="label-conteudo">{{}}</div>
                    </div>

                    <div class="documento-suspenso">
                        <div class="titulo-conteudo-detalhes"> Suspenso </div>
                        <div class="label-conteudo">{{infoTitulo.suspensoTexto}}</div>
                    </div>       
                    
                    <div class="documento-vendedor">
                        <div class="titulo-conteudo-detalhes"> Vendedor </div>
                        <div class="label-conteudo">{{infoTitulo.nomeRepresentante}}</div>
                    </div>

                    <div class="documento-comissao">
                        <div class="titulo-conteudo-detalhes"></div>
                        <div class="label-conteudo"></div>
                    </div>
                </div>


<div class="html2pdf__page-break" />        



                <div class="titulo-grupo-detalhes"> Pagamentos </div>
                <div class="grupo-pagamentos">
                    <div class="pagamentos-dataPgto">
                        <div class="titulo-conteudo-detalhes"> Data Pagamento </div>
                        <div class="label-conteudo">{{infoTitulo.dataPagamentoFormatada}}</div>
                    </div>

                    <div class="pagamentos-valor">
                        <div class="titulo-conteudo-detalhes"> Valor Pagamento </div>
                        <div class="label-conteudo">R${{infoTitulo.valorPagamento}}</div>
                    </div>

                    <div class="pagamentos-portador">
                        <div class="titulo-conteudo-detalhes"> Portador </div>
                        <div class="label-conteudo">{{infoTitulo.nomePortador}}</div>
                    </div>                    
                </div>
            </div>
        </g-card>
    </div>
</template>

<script>
import PDFDetalhesTitulo from './PDFDetalhesTitulo.js' 
export default PDFDetalhesTitulo
</script>

<style scoped>
.unidade-representante {
    position: absolute;
    right: 50px;
    top: 20px;
}
.header-icons {
    display: flex;
    justify-self: center;
    column-gap: 5px;
}

.header-titulo-voltar {
    width: 100%;
    display: flex;
    align-items: flex-end;
}

.detalhes-titulo-titulo {
  color: #4f4c4d;
  font-family: "MontSerrat";
  font-size: 20px;
  font-weight: bold;
  text-align: left;
}

.topico {
    padding-bottom: 20px;
}

.grupo {
    color: #4f2c19;
    text-align: left;
    font-family: "MontSerrat";
    font-weight: bold;
    margin-top: 30px;
    display: flex;
}

.titulo {
    color: #3e3e3e;
    text-align: left;
    font-family: "MontSerrat";
    font-weight: 500;
    margin-top: 15px;
}

.conteudo {
    color: #8a8a8a;
    text-align: left;
    font-family: "MontSerrat";
    margin-bottom: 10px;
}

.grid-demaisCaract-critica {
    margin-top: 25px;
}

.detalhes{
    cursor: pointer;
    font: normal normal 600 13px/23px Montserrat;
    color: #5a5a5a;
    text-decoration: underline;
    align-items: baseline;
}

@media(min-width:310px) {
    .grupo-documento{
       display: flex;
       flex-direction: column;
    }
    .grupo-pagamentos{
        display: flex;
       flex-direction: column;
    }
    .header-detalhes-titulo {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        padding: 20px 0 10px;
    }

    .topico  {
        display: flex;
        flex-wrap: wrap;
        column-gap: 15%;
    }

    .grupo {
        font-size: 18px;
    }
} 

 @media(min-width:368px) {
    .grupo-documento{
        display: grid;
        grid-template-columns: repeat(2, minmax(4em, 1fr));
        grid-template-rows: repeat(12, auto);
        column-gap: 3%;
    }
    .grupo-pagamentos{
        display: grid;
        grid-template-columns: repeat(2, minmax(4em, 1fr));
        grid-template-rows: repeat(1, auto);
        column-gap: 3%;
    }
    .header-detalhes-titulo {
    grid-template-columns: 25% repeat(3, auto);
    }
} 

 @media(min-width:600px) {
    .grupo-documento{
        display: grid;
        grid-template-columns: repeat(2, minmax(4em, 1fr));
        grid-template-rows: repeat(12, auto);
        column-gap: 3%;
    }

    .grupo-pagamentos{
        display: grid;
        grid-template-columns: repeat(2, minmax(4em, 1fr));
        grid-template-rows: repeat(1, auto);
        column-gap: 3%;
    }

}

 @media(min-width:801px) {
    .grupo-documento{
        display: grid;
        grid-template-columns: repeat(3, minmax(4em, 1fr));
        grid-template-rows: repeat(9, auto);
        column-gap: 3%;
    }

    .grupo-pagamentos{
        display: grid;
        grid-template-columns: repeat(3, minmax(4em, 1fr));
        grid-template-rows: repeat(1, auto);
        column-gap: 3%;
    }
    .conteudo-card-detalhes-titulo {
    padding: 0 30px;
    }
} 

@media(min-width:1025px) {
    .grupo-documento{
        display: grid;
        grid-template-columns: repeat(4, minmax(4em, 1fr));
        grid-template-rows: repeat(7, auto);
        column-gap: 3%;
    }
    .grupo-pagamentos{
        display: grid;
        grid-template-columns: repeat(4, minmax(4em, 1fr));
        grid-template-rows: repeat(1, auto);
        column-gap: 3%;
    }
    .conteudo-card-detalhes-titulo {
    padding: 0 50px;
    }

    .grupo-documento, .grupo-pagamentos {
    border-bottom: none;
    margin-top: 10px;
    column-gap: 6%;
    }

    .grupo {
    font-size: 19px;
    }
}

@media(min-width:1285px) {
    .grupo-documento{
        display: grid;
        grid-template-columns: repeat(5, minmax(4em, 1fr));
        grid-template-rows: repeat(5, auto);
        column-gap: 3%;
    }
    .grupo-pagamentos{
        display: grid;
        grid-template-columns: repeat(5, minmax(4em, 1fr));
        grid-template-rows: repeat(1, auto);
        column-gap: 3%;
    }
}

@media(min-width:1500px) {
    .grupo-documento{
        display: grid;
        grid-template-columns: repeat(3, minmax(4em, 1fr));
        grid-template-rows: repeat(5, auto);
        column-gap: 3%;
    }
    .grupo-pagamentos{
        display: grid;
        grid-template-columns: repeat(4, minmax(4em, 1fr));
        grid-template-rows: repeat(1, auto);
        column-gap: 3%;
    }
}
</style>